import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

export type OrganizationWorkflowOptionsSavedAction = {
	type: 'ORGANIZATION_WORKFLOW_OPTIONS_SAVED';
	payload: OrganizationWorkflowPayload;
	organizationId: number;
};

export default (
	payload: OrganizationWorkflowPayload,
	organizationId: number,
): OrganizationWorkflowOptionsSavedAction => ({
	type: 'ORGANIZATION_WORKFLOW_OPTIONS_SAVED',
	payload,
	organizationId,
});
